import { LineMenu } from '@qr-front/icons/line-menu'

export const MobileMenuTrigger = ({
	onPointerDown,
}: {
	onPointerDown?: () => void
}) => (
	<LineMenu
		className="cursor-pointer transition-colors active:text-blue hover:text-blue"
		onPointerDown={onPointerDown}
	/>
)
